// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface CognitState {
  email: string;
  password: string;
  password1: string; //used for new password reset
  password2: string; //used for new password reset
  newPasswordRequired: boolean;
  errorMessage: string;
  qrCodeUrl: string | null;
  mfaCode: string;
  showMfaInput: boolean;
  isLoading: boolean;
  authenticated: boolean;
}

const initialState: CognitState = {
  email: '',
  password: '',
  password1: '',
  password2: '',
  newPasswordRequired: false,
  errorMessage: '',
  qrCodeUrl: null,
  mfaCode: '',
  showMfaInput: false,
  isLoading: false,
  authenticated: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setMfaCode: (state, action) => {
      state.mfaCode = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.authenticated = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setShowMfaInput: (state, action) => {
      state.showMfaInput = action.payload;
    },
    setQrCodeUrl: (state, action) => {
      state.qrCodeUrl = action.payload;
    },
    setNewPasswordRequired: (state, action) => {
      state.newPasswordRequired = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    },
    setPassword1: (state, action) => {
      state.password1 = action.payload;
    },
    setPassword2: (state, action) => {
      state.password2 = action.payload;
    },
  },
});

export const {
  setMfaCode,
  setErrorMessage,
  setAuthenticated,
  setIsLoading,
  setShowMfaInput,
  setQrCodeUrl,
  setEmail,
  setPassword,
  setPassword1,
  setPassword2,
  setNewPasswordRequired,
} = authSlice.actions;

export default authSlice.reducer;
